import Ellipsis from './Ellipsis'

export default Ellipsis



// WEBPACK FOOTER //
// ./src/components/Ellipsis/index.js